export default __webpack_public_path__ + "static/combination-of-different-series-types-c23fdbd7d00cf368a5e390c3a6765fdc.png";